import { render, staticRenderFns } from "./VehiculoDetail.vue?vue&type=template&id=6e0c1e5c&scoped=true"
import script from "./VehiculoDetail.vue?vue&type=script&lang=js"
export * from "./VehiculoDetail.vue?vue&type=script&lang=js"
import style0 from "./VehiculoDetail.vue?vue&type=style&index=0&id=6e0c1e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c1e5c",
  null
  
)

export default component.exports